// extracted by mini-css-extract-plugin
export default {"content":"AeLvf_G8EvSKJS_9v9iO","acceptance":"fBiv8bdBGQ8d1vDCh_WX","acceptanceName":"r12yShKjOLoj2RKMWpoc","list":"GXP9v5kXTCkuDlIWpicy","buttons":"FzCwffIyMs4MAsDq_znC"};